import { render, staticRenderFns } from "./examTip.vue?vue&type=template&id=7f6d8a2a&scoped=true"
import script from "./examTip.vue?vue&type=script&lang=js"
export * from "./examTip.vue?vue&type=script&lang=js"
import style0 from "./examTip.vue?vue&type=style&index=0&id=7f6d8a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d8a2a",
  null
  
)

export default component.exports